// @flow
import orgInactiveNotificationsEntity from './entity'
import {
  ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY,
  ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID,
  ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE,
} from './actionTypes'

orgInactiveNotificationsEntity.addActions([
  {
    name: 'changeRepeatDay',
    type: ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY,
    action: (day: number) => ({
      type: ORG_INACTIVE_NOTIFICATIONS_CHANGE_REPEAT_DAY,
      payload: {
        day,
      },
    }),
  },
  {
    name: 'setBeforeCreateId',
    type: ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID,
    action: (id: number) => ({
      type: ORG_INACTIVE_NOTIFICATIONS_SET_BEFORE_CREATE_ID,
      payload: {
        id,
      },
    }),
  },
  {
    name: 'setIdToDelete',
    type: ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE,
    action: (id: number) => ({
      type: ORG_INACTIVE_NOTIFICATIONS_SET_ID_TO_DELETE,
      payload: {
        id,
      },
    }),
  },
])

export default orgInactiveNotificationsEntity.getActions()
